// extracted by css-extract-rspack-plugin
export default {"container":"container__l9ZFK"};